import { render, staticRenderFns } from "./studyRule.vue?vue&type=template&id=4f5d5553&scoped=true&"
import script from "./studyRule.vue?vue&type=script&lang=js&"
export * from "./studyRule.vue?vue&type=script&lang=js&"
import style0 from "./studyRule.vue?vue&type=style&index=0&id=4f5d5553&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5d5553",
  null
  
)

export default component.exports